import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/authentication/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./modules/tab-home/tab-home.module').then(
        (m) => m.TabHomePageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Home' },
  },
  {
    path: 'bajaj',
    loadChildren: () =>
      import('./modules/travel-tabs/travel-tabs.module').then(
        (m) => m.TravelTabsPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Bajaj' },
  },
  {
    path: 'airport',
    children: [
      {
        path: 'flights',
        loadChildren: () =>
          import('./modules/airport/flights/flights.module').then(
            (m) => m.FlightsPageModule
          ),
        canActivate: [AuthGuard],
        data: { title: 'Airport Flights' },
      },
      {
        path: 'cabs-international',
        loadChildren: () =>
          import(
            './modules/airport/cabs-international/cabs-international.module'
          ).then((m) => m.CabsInternationalPageModule),
        canActivate: [AuthGuard],
        data: { title: 'Airport Cabs International' },
      },
      {
        path: 'lounges',
        loadChildren: () =>
          import('./modules/service-list/service-list.module').then(
            (m) => m.ServiceListPageModule
          ),
        canActivate: [AuthGuard],
        data: { title: 'Airport Lounges' },
      },
      {
        path: 'meet-and-greet',
        loadChildren: () =>
          import('./modules/service-list/service-list.module').then(
            (m) => m.ServiceListPageModule
          ),
        canActivate: [AuthGuard],
        data: { title: 'Airport Meet and Greet' },
      },
      {
        path: 'parking',
        loadChildren: () =>
          import('./modules/service-list/service-list.module').then(
            (m) => m.ServiceListPageModule
          ),
        canActivate: [AuthGuard],
        data: { title: 'Airport Parking' },
      },
      {
        path: 'porter',
        loadChildren: () =>
          import('./modules/service-list/service-list.module').then(
            (m) => m.ServiceListPageModule
          ),
        canActivate: [AuthGuard],
        data: { title: 'Airport Porter' },
      },
      {
        path: 'spa',
        loadChildren: () =>
          import('./modules/service-list/service-list.module').then(
            (m) => m.ServiceListPageModule
          ),
        canActivate: [AuthGuard],
        data: { title: 'Airport Spa' },
      },
      {
        path: 'dutyfree',
        loadChildren: () =>
          import('./modules/airport/dutyfree-home/dutyfree-home.module').then(
            (m) => m.DutyfreeHomePageModule
          ),
        canActivate: [AuthGuard],
        data: { title: 'Airport Dutyfree' },
      },
      {
        path: 'baggage-insurance',
        loadChildren: () =>
          import(
            './modules/airport/baggage-insurance/baggage-insurance.module'
          ).then((m) => m.BaggageInsurancePageModule),
        canActivate: [AuthGuard],
        data: { title: 'Airport Baggage Insurance' },
      },
      {
        path: 'service-request',
        loadChildren: () =>
          import(
            './modules/airport/baggage-insurance/baggage-insurance.module'
          ).then((m) => m.BaggageInsurancePageModule),
        canActivate: [AuthGuard],
        data: { title: 'Airport Service Request' },
      },
      {
        path: 'airport-detail',
        loadChildren: () =>
          import(
            '../app/modules/airport/airport-companion/airport-companion.module'
          ).then((m) => m.AirportCompanionPageModule),
        canActivate: [AuthGuard],
        data: { title: 'Airport Detail' },
      },
      {
        path: 'hotel/search',
        loadChildren: () =>
          import('./modules/booking/hotels/search/search.module').then(
            (m) => m.SearchPageModule
          ),
        canActivate: [AuthGuard],
        data: { title: 'Airport Hotel Search' },
      },
    ],
    data: { title: 'Airport' },
  },

  {
    path: 'local',
    children: [
      {
        path: 'clubs',
        loadChildren: () =>
          import('./modules/clubs/clubs-home/clubs-home.module').then(
            (m) => m.ClubsHomePageModule
          ),
        canActivate: [AuthGuard],
        data: { title: 'Local Clubs' },
      },
      {
        path: 'staycation',
        loadChildren: () =>
          import('./modules/service-list/service-list.module').then(
            (m) => m.ServiceListPageModule
          ),
        canActivate: [AuthGuard],
        data: { title: 'Local Staycation' },
      },
      {
        path: 'restaurant',
        loadChildren: () =>
          import('./modules/service-list/service-list.module').then(
            (m) => m.ServiceListPageModule
          ),
        canActivate: [AuthGuard],
        data: { title: 'Local Restaurant' },
      },
      {
        path: 'gym',
        loadChildren: () =>
          import('./modules/service-list/service-list.module').then(
            (m) => m.ServiceListPageModule
          ),
        canActivate: [AuthGuard],
        data: { title: 'Local Gym' },
      },
      {
        path: 'spa',
        loadChildren: () =>
          import('./modules/service-list/service-list.module').then(
            (m) => m.ServiceListPageModule
          ),
        canActivate: [AuthGuard],
        data: { title: 'Local Spa' },
      },
      {
        path: 'baggage-insurance',
        loadChildren: () =>
          import(
            './modules/airport/baggage-insurance/baggage-insurance.module'
          ).then((m) => m.BaggageInsurancePageModule),
        canActivate: [AuthGuard],
        data: { title: 'Local Baggage Insurance' },
      },
      {
        path: 'service-request',
        loadChildren: () =>
          import(
            './modules/airport/baggage-insurance/baggage-insurance.module'
          ).then((m) => m.BaggageInsurancePageModule),
        canActivate: [AuthGuard],
        data: { title: 'Local Service Request' },
      },
      {
        path: 'online-offers',
        loadChildren: () =>
          import(
            './modules/shopping/online-shopping-home/online-shopping-home.module'
          ).then((m) => m.OnlineShoppingHomePageModule),
        canActivate: [AuthGuard],
        data: { title: 'Local Online Offers' },
      },
      {
        path: 'hotel/search',
        loadChildren: () =>
          import('./modules/booking/hotels/search/search.module').then(
            (m) => m.SearchPageModule
          ),
        canActivate: [AuthGuard],
        data: { title: 'Hotel Search' },
      },
    ],
    data: { title: 'Local' },
  },

  {
    path: 'tours-and-experiences',
    children: [
      {
        path: 'search',
        loadChildren: () =>
          import(
            './modules/tours-and-experiences/tours-and-experiences-search/tours-and-experiences-search.module'
          ).then((m) => m.ToursAndExperiencesSearchPageModule),
        canActivate: [AuthGuard],
        data: { title: 'Tours and Experiences Search' },
      },
      {
        path: 'city-details/:city',
        loadChildren: () =>
          import(
            './modules/tours-and-experiences/tours-and-experiences-city-details/tours-and-experiences-city-details.module'
          ).then((m) => m.ToursAndExperiencesCityDetailsPageModule),
        canActivate: [AuthGuard],
        data: { title: 'Tours and Experiences City Details' },
      },
      {
        path: 'service-details/:serviceId',
        loadChildren: () =>
          import(
            './modules/tours-and-experiences/tours-and-experiences-service-details/tours-and-experiences-service-details.module'
          ).then((m) => m.ToursAndExperiencesServiceDetailsPageModule),
        canActivate: [AuthGuard],
        data: { title: 'Tours and Experiences Service Details' },
      },
      {
        path: 'service-list/:carouselId/:city',
        loadChildren: () =>
          import(
            './modules/tours-and-experiences/tours-and-experiences-service-list/tours-and-experiences-service-list.module'
          ).then((m) => m.ToursAndExperiencesServiceListPageModule),
        canActivate: [AuthGuard],
        data: { title: 'Tours and Experiences Service List' },
      },
      {
        path: 'booking-review/:serviceId/:locationId',
        loadChildren: () =>
          import(
            './modules/tours-and-experiences/tours-and-experiences-booking-review/tours-and-experiences-booking-review.module'
          ).then((m) => m.ToursAndExperiencesBookingReviewPageModule),
        canActivate: [AuthGuard],
        data: { title: 'Tours and Experiences Booking Review' },
      },
      {
        path: 'city-list/:carouselId',
        loadChildren: () =>
          import(
            './modules/tours-and-experiences/tours-and-experiences-city-list/tours-and-experiences-city-list.module'
          ).then((m) => m.ToursAndExperiencesCityListPageModule),
        canActivate: [AuthGuard],
        data: { title: 'Tours and Experiences City List' },
      },
    ],
    data: { title: 'Tours and Experiences' },
  },
  {
    path: 'bus/search',
    loadChildren: () =>
      import('./modules/booking/bus/bus-search/bus-search.module').then(
        (m) => m.BusSearchPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Bus Search' },
  },
  {
    path: 'bus/search-results',
    loadChildren: () =>
      import(
        './modules/booking/bus/bus-search-results/bus-search-results.module'
      ).then((m) => m.BusSearchResultsPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Bus Search Results' },
  },
  {
    path: 'bus/booking-review/:resultId',
    loadChildren: () =>
      import(
        './modules/booking/bus/bus-booking-review/bus-booking-review.module'
      ).then((m) => m.BusBookingReviewPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Bus Booking Review' },
  },
  {
    path: 'bus/seat-selection/:resultId',
    loadChildren: () =>
      import(
        './modules/booking/bus/bus-seat-selection/seat-selection.module'
      ).then((m) => m.SeatSelectionPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Bus Seat Selection' },
  },
  {
    path: 'bus/booking-confirmation/:bookingReferenceId',
    loadChildren: () =>
      import(
        './modules/booking/bus/bus-booking-confirmation/bus-booking-confirmation.module'
      ).then((m) => m.BusBookingConfirmationPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Bus Booking Confirmation' },
  },
  {
    path: 'esim/search',
    loadChildren: () =>
      import('./modules/esim/search/search.module').then(
        (m) => m.SearchPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Esim Search' },
  },
  {
    path: 'esim/booking-review/:productId',
    loadChildren: () =>
      import('./modules/esim/booking-review/booking-review.module').then(
        (m) => m.BookingReviewPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Esim Booking Review' },
  },
  {
    path: 'esim/booking-status/:resultId',
    loadChildren: () =>
      import(
        './modules/booking/bus/bus-booking-review/bus-booking-review.module'
      ).then((m) => m.BusBookingReviewPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Esim Booking Review' },
  },
  {
    path: 'esim/booking-detail/:bookingReferenceId',
    loadChildren: () =>
      import('./modules/esim/booking-details/booking-details.module').then(
        (m) => m.BookingDetailsPageModule
      ),
    data: { title: 'Esim Booking Detail' },
  },

  {
    path: 'onboarding',
    loadChildren: () =>
      import('./modules/onboarding/onboarding.module').then(
        (m) => m.OnboardingPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Onboarding' },
  },

  {
    path: 'clubs',
    loadChildren: () =>
      import('./modules/clubs/clubs-home/clubs-home.module').then(
        (m) => m.ClubsHomePageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Clubs' },
  },
  {
    path: 'clubs/:country/:city',
    loadChildren: () =>
      import('./modules/clubs/clubs-home/clubs-home.module').then(
        (m) => m.ClubsHomePageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Clubs' },
  },
  {
    path: 'club/:country/:city/:clubId',
    loadChildren: () =>
      import('./modules/clubs/clubs-detail/clubs-detail.module').then(
        (m) => m.ClubsDetailPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Club Details' },
  },
  {
    path: 'club-request/:clubId',
    loadChildren: () =>
      import('./modules/clubs/club-request/club-request.module').then(
        (m) => m.ClubRequestPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Club Request' },
  },
  {
    path: 'airport',
    loadChildren: () =>
      import('./modules/airport/airport-home/airport-home.module').then(
        (m) => m.AirportHomePageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Airport Home' },
  },
  {
    path: 'airport/map',
    loadChildren: () =>
      import('./modules/airport/airport-map/airport-map.module').then(
        (m) => m.AirportMapPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Airport Map' },
  },
  {
    path: 'flights',
    loadChildren: () =>
      import('./modules/airport/flights/flights.module').then(
        (m) => m.FlightsPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Flights' },
  },
  {
    path: 'flight/:flightid/:origin/:dest',
    loadChildren: () =>
      import(
        './modules/airport/flights/flight-detail/flight-detail.module'
      ).then((m) => m.FlightDetailPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Flight Details' },
  },
  {
    path: 'flight/:legNo',
    loadChildren: () =>
      import(
        './modules/airport/flights/flight-detail/flight-detail.module'
      ).then((m) => m.FlightDetailPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Flight Details' },
  },
  {
    path: 'flight-search/id/:flightToken',
    loadChildren: () =>
      import(
        './modules/airport/flights/flight-search/flight-search.module'
      ).then((m) => m.FlightSearchPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Flight Search' },
  },
  {
    path: 'flight-search/route/:flightRoute',
    loadChildren: () =>
      import(
        './modules/airport/flights/flight-search/flight-search.module'
      ).then((m) => m.FlightSearchPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Flight Search' },
  },
  {
    path: 'imported-flights',
    loadChildren: () =>
      import(
        './modules/airport/flights/calender-flights/calender-flights.module'
      ).then((m) => m.CalenderFlightsPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Imported Flights' },
  },
  {
    path: 'cabs-domestic',
    loadChildren: () =>
      import('./modules/airport/cabs-domestic/cabs-domestic.module').then(
        (m) => m.CabsDomesticPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Cabs Domestic' },
  },
  {
    path: 'cabs-international',
    loadChildren: () =>
      import(
        './modules/airport/cabs-international/cabs-international.module'
      ).then((m) => m.CabsInternationalPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Cabs International' },
  },
  {
    path: 'lounges',
    loadChildren: () =>
      import('./modules/service-list/service-list.module').then(
        (m) => m.ServiceListPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Lounges' },
  },
  {
    path: 'meet-and-greet',
    loadChildren: () =>
      import('./modules/service-list/service-list.module').then(
        (m) => m.ServiceListPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Meet and Greet' },
  },
  {
    path: 'parking',
    loadChildren: () =>
      import('./modules/service-list/service-list.module').then(
        (m) => m.ServiceListPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Parking' },
  },
  {
    path: 'porter',
    loadChildren: () =>
      import('./modules/service-list/service-list.module').then(
        (m) => m.ServiceListPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Porter' },
  },
  {
    path: 'restaurant',
    loadChildren: () =>
      import('./modules/service-list/service-list.module').then(
        (m) => m.ServiceListPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Restaurant' },
  },
  {
    path: 'gym',
    loadChildren: () =>
      import('./modules/service-list/service-list.module').then(
        (m) => m.ServiceListPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Gym' },
  },
  {
    path: 'spa',
    loadChildren: () =>
      import('./modules/service-list/service-list.module').then(
        (m) => m.ServiceListPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Spa' },
  },
  {
    path: 'restaurant/:serviceId',
    loadChildren: () =>
      import('./modules/service-details/service-details.module').then(
        (m) => m.ServiceDetailsPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Restaurant Details' },
  },
  {
    path: 'restaurant/:serviceId/:location',
    loadChildren: () =>
      import('./modules/service-details/service-details.module').then(
        (m) => m.ServiceDetailsPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Restaurant Details' },
  },
  {
    path: 'gym/:serviceId',
    loadChildren: () =>
      import('./modules/service-details/service-details.module').then(
        (m) => m.ServiceDetailsPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Gym Details' },
  },
  {
    path: 'gym/:serviceId/:location',
    loadChildren: () =>
      import('./modules/service-details/service-details.module').then(
        (m) => m.ServiceDetailsPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Gym Details' },
  },
  {
    path: 'lounge/search',
    loadChildren: () =>
      import(
        './modules/booking/lounge/lounge-search/lounge-search.module'
      ).then((m) => m.LoungeSearchPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Lounge Search' },
  },
  {
    path: 'lounge/search-results/:airportId/:terminal',
    loadChildren: () =>
      import(
        './modules/booking/lounge/lounge-search-results/lounge-search-results.module'
      ).then((m) => m.LoungeSearchResultsPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Lounge Search Results' },
  },
  {
    path: 'lounge/details/:productId/:optionId',
    loadChildren: () =>
      import(
        './modules/booking/lounge/lounge-details/lounge-details.module'
      ).then((m) => m.LoungeDetailsPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Lounge Details' },
  },
  {
    path: 'lounge/booking-review',
    loadChildren: () =>
      import(
        './modules/booking/lounge/lounge-booking-review/lounge-booking-review.module'
      ).then((m) => m.LoungeBookingReviewPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Lounge Booking Review' },
  },
  {
    path: 'lounge/booking-confirmation/:bookingReferenceId',
    loadChildren: () =>
      import(
        './modules/booking/lounge/lounge-booking-confirmation/lounge-booking-confirmation.module'
      ).then((m) => m.LoungeBookingConfirmationPageModule),
    data: { title: 'Lounge Booking Confirmation' },
  },
  {
    path: 'lounge/:serviceId',
    loadChildren: () =>
      import('./modules/service-details/service-details.module').then(
        (m) => m.ServiceDetailsPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Lounge Details' },
  },
  {
    path: 'lounge/:serviceId/:location',
    loadChildren: () =>
      import('./modules/service-details/service-details.module').then(
        (m) => m.ServiceDetailsPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Lounge Details' },
  },
  {
    path: 'fasttrack/search',
    loadChildren: () =>
      import(
        './modules/booking/fasttrack/fasttrack-search/fasttrack-search.module'
      ).then((m) => m.FasttrackSearchPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Fast Track Search' },
  },
  {
    path: 'fasttrack/search-results',
    loadChildren: () =>
      import(
        './modules/booking/fasttrack/fasttrack-search-results/fasttrack-search-results.module'
      ).then((m) => m.FasttrackSearchResultsPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Fast Track Search Results' },
  },
  {
    path: 'fasttrack/details/:productId/:optionId',
    loadChildren: () =>
      import(
        './modules/booking/fasttrack/fasttrack-details/fasttrack-details.module'
      ).then((m) => m.FasttrackDetailsPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Fast Track Details' },
  },
  {
    path: 'fasttrack/booking-review/:productId/:optionId',
    loadChildren: () =>
      import(
        './modules/booking/fasttrack/fasttrack-booking-review/fasttrack-booking-review.module'
      ).then((m) => m.FasttrackBookingReviewPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Fast Track Booking Review' },
  },
  {
    path: 'fasttrack/booking-confirmation/:bookingReferenceId',
    loadChildren: () =>
      import(
        './modules/booking/fasttrack/fasttrack-booking-confirmation/fasttrack-booking-confirmation.module'
      ).then((m) => m.FasttrackBookingConfirmationPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Fast Track Booking Confirmation' },
  },

  {
    path: 'support',
    loadChildren: () =>
      import('./modules/account/account-global/account-global.module').then(
        (m) => m.AccountGlobalPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Support' },
  },
  {
    path: 'about-us',
    loadChildren: () =>
      import('./modules/account/about-us/about-us.module').then(
        (m) => m.AboutUsPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'About Us' },
  },
  {
    path: 'user-guests',
    loadChildren: () =>
      import('./modules/account/user-guests/user-guests.module').then(
        (m) => m.UserGuestsPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'User Guests' },
  },
  {
    path: 'activity-history',
    loadChildren: () =>
      import('./modules/account/cashback/cashback.module').then(
        (m) => m.CashbackPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Activity History' },
  },
  {
    path: 'contact-us',
    loadChildren: () =>
      import('./modules/account/account-global/account-global.module').then(
        (m) => m.AccountGlobalPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Contact Us' },
  },
  {
    path: 'account/cashback',
    loadChildren: () =>
      import('./modules/account/cashback/cashback.module').then(
        (m) => m.CashbackPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Cashback' },
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/authentication/authentication.module').then(
        (m) => m.AuthenticationPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Login' },
  },
  {
    path: 'registration',
    loadChildren: () =>
      import('./modules/account/registration/registration.module').then(
        (m) => m.RegistrationPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Registration' },
  },
  {
    path: 'privacy-policy',
    loadChildren: () =>
      import('./modules/account/privacy-policy/privacy-policy.module').then(
        (m) => m.PrivacyPolicyPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Privacy Policy' },
  },
  {
    path: 'faq',
    loadChildren: () =>
      import('./modules/account/faq/faq.module').then((m) => m.FaqPageModule),
    canActivate: [AuthGuard],
    data: { title: 'FAQ' },
  },
  {
    path: 'terms-and-condition',
    loadChildren: () =>
      import('./modules/account/terms-condition/terms-condition.module').then(
        (m) => m.TermsConditionPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Terms and Condition' },
  },
  {
    path: 'my-bookings',
    loadChildren: () =>
      import('./modules/account/my-bookings/my-bookings.module').then(
        (m) => m.MyBookingsPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'My Bookings' },
  },
  {
    path: 'my-requests',
    loadChildren: () =>
      import('./modules/account/my-request/my-request.module').then(
        (m) => m.MyRequestPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'My Requests' },
  },

  {
    path: 'dutyfree',
    loadChildren: () =>
      import('./modules/airport/dutyfree-home/dutyfree-home.module').then(
        (m) => m.DutyfreeHomePageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Dutyfree' },
  },
  {
    path: 'facilities',
    loadChildren: () =>
      import('./modules/airport/dutyfree-home/dutyfree-home.module').then(
        (m) => m.DutyfreeHomePageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Facilities' },
  },
  {
    path: 'dutyfree-detail/:retailerId',
    loadChildren: () =>
      import('./modules/airport/dutyfree-detail/dutyfree-detail.module').then(
        (m) => m.DutyfreeDetailPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Dutyfree Detail' },
  },
  {
    path: 'facility-detail/:retailerId',
    loadChildren: () =>
      import('./modules/airport/dutyfree-detail/dutyfree-detail.module').then(
        (m) => m.DutyfreeDetailPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Facility Detail' },
  },
  {
    path: 'dutyfree/products/:storeName/:storeId',
    loadChildren: () =>
      import('./modules/airport/products-list/products-list.module').then(
        (m) => m.ProductsListPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Dutyfree Products' },
  },
  {
    path: 'dutyfree/product/:productId',
    loadChildren: () =>
      import('./modules/airport/product-detail/product-detail.module').then(
        (m) => m.ProductDetailPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Dutyfree Product Detail' },
  },
  {
    path: 'dutyfree/retail/cart',
    loadChildren: () =>
      import('./modules/airport/retail-cart/retail-cart.module').then(
        (m) => m.RetailCartPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Dutyfree Retail Cart' },
  },
  {
    path: 'dutyfreeV2',
    loadChildren: () =>
      import('./modules/dutyfree/dutyfree-home/dutyfree-home.module').then(
        (m) => m.DutyfreeHomePageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Dutyfree V2' },
  },
  {
    path: 'dutyfreeV2/dutyfree-detail/:retailerId',
    loadChildren: () =>
      import('./modules/dutyfree/dutyfree-detail/dutyfree-detail.module').then(
        (m) => m.DutyfreeDetailPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Dutyfree Detail V2' },
  },
  {
    path: 'dutyfreeV2/products/:storeName/:storeId',
    loadChildren: () =>
      import(
        './modules/dutyfree/dutyfree-products-list/dutyfree-products-list.module'
      ).then((m) => m.DutyfreeProductsListPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Dutyfree Products V2' },
  },
  {
    path: 'dutyfreeV2/product/:productId',
    loadChildren: () =>
      import(
        './modules/dutyfree/dutyfree-product-detail/dutyfree-product-detail.module'
      ).then((m) => m.DutyfreeProductDetailPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Dutyfree Product Detail V2' },
  },
  {
    path: 'dutyfreeV2/retail/cart',
    loadChildren: () =>
      import('./modules/dutyfree/dutyfree-cart/dutyfree-cart.module').then(
        (m) => m.CartPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Dutyfree Retail Cart V2' },
  },
  {
    path: 'dutyfreeV2/order/:id',
    loadChildren: () =>
      import(
        './modules/dutyfree/dutyfree-order-detail/dutyfree-order-detail.module'
      ).then((m) => m.DutyfreeOrderDetailPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Duty Free Order V2' },
  },
  {
    path: 'dutyfreeV2/order-review',
    loadChildren: () =>
      import('./modules/dutyfree/order-review/order-review.module').then(
        (m) => m.OrderReviewPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Dutyfree Order Review V2' },
  },
  {
    path: 'dutyfreeV2/order-confirmed/:orderId',
    loadChildren: () =>
      import(
        './modules/dutyfree/dutyfree-order-confirmed/dutyfree-order-confirmed.module'
      ).then((m) => m.OrderConfirmedPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Dutyfree Order Confirmed V2' },
  },
  {
    path: 'membership/:id',
    loadChildren: () =>
      import('./modules/membership-details/membership-details.module').then(
        (m) => m.MembershipDetailsPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Membership Details' },
  },
  {
    path: 'baggage-insurance',
    loadChildren: () =>
      import(
        './modules/airport/baggage-insurance/baggage-insurance.module'
      ).then((m) => m.BaggageInsurancePageModule),
    canActivate: [AuthGuard],
    data: { title: 'Baggage Insurance' },
  },
  {
    path: 'service-request',
    loadChildren: () =>
      import(
        './modules/airport/baggage-insurance/baggage-insurance.module'
      ).then((m) => m.BaggageInsurancePageModule),
    canActivate: [AuthGuard],
    data: { title: 'Service Request' },
  },
  {
    path: 'my-membership',
    loadChildren: () =>
      import('./modules/my-membership/my-membership.module').then(
        (m) => m.MyMembershipPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'My Membership' },
  },
  {
    path: 'activate-membership',
    loadChildren: () =>
      import('./modules/activate-membership/activate-membership.module').then(
        (m) => m.ActivateMembershipPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Activate Membership' },
  },
  {
    path: 'airport-detail',
    loadChildren: () =>
      import(
        '../app/modules/airport/airport-companion/airport-companion.module'
      ).then((m) => m.AirportCompanionPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Airport Detail' },
  },
  {
    path: 'airport-detail/:airportCode',
    loadChildren: () =>
      import(
        '../app/modules/airport/airport-companion/airport-companion.module'
      ).then((m) => m.AirportCompanionPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Airport Detail' },
  },
  {
    path: 'booking-detail',
    loadChildren: () =>
      import('./modules/booking-detail/booking-detail.module').then(
        (m) => m.BookingDetailPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Booking Detail' },
  },
  {
    // Shared post-checkout interstitial (order summary + email-sent note + login prompt).
    // No AuthGuard: it is shown to guests precisely to prompt login.
    path: 'booking-summary',
    loadChildren: () =>
      import('./modules/booking-summary/booking-summary.module').then(
        (m) => m.BookingSummaryPageModule
      ),
    data: { title: 'Booking Summary' },
  },
  {
    path: 'history',
    loadChildren: () =>
      import('./modules/history/history.module').then(
        (m) => m.HistoryPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'History' },
  },
  {
    path: 'order-history',
    loadChildren: () =>
      import('./modules/order-history/order-history.module').then(
        (m) => m.OrderHistoryPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Order History' },
  },
  {
    path: 'results/:id',
    loadChildren: () =>
      import('./modules/results/results.module').then(
        (m) => m.ResultsPageModule
      ),
    data: { title: 'Results' },
  },
  {
    path: 'flight-booking/v2/search',
    loadChildren: () =>
      import('./modules/booking/flights-v2/search/search.module').then(
        (m) => m.SearchPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Flight Booking V2 Search' },
  },
  {
    path: 'jsp/search',
    loadChildren: () =>
      import(
        './modules/booking/flights/flights-jsp-search/flights-jsp-search.module'
      ).then((m) => m.FlightsJspSearchPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Journey Select Plus Search' },
  },
  {
    path: 'flexicancel/v2/search',
    loadChildren: () =>
      import('./modules/booking/flights-v2/search/search.module').then(
        (m) => m.SearchPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Flight Booking V2 Search' },
  },
  {
    path: 'flight-booking/v2/search-results',
    loadChildren: () =>
      import(
        './modules/booking/flights-v2/search-results/search-results.module'
      ).then((m) => m.SearchResultsPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Flight Booking V2 Search Results' },
  },
  {
    path: 'flexicancel/v2/search-results',
    loadChildren: () =>
      import(
        './modules/booking/flights-v2/search-results/search-results.module'
      ).then((m) => m.SearchResultsPageModule),
    canActivate: [AuthGuard],
    data: { title: 'FlexiCancel V2 Search Results' },
  },
  {
    path: 'flight-booking/v2/booking-review/:resultId',
    loadChildren: () =>
      import(
        './modules/booking/flights-v2/booking-review/booking-review.module'
      ).then((m) => m.FlightReviewPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Flight Booking V2 Review' },
  },
  {
    path: 'flexicancel/v2/booking-review/:resultId',
    loadChildren: () =>
      import(
        './modules/booking/flights-v2/booking-review/booking-review.module'
      ).then((m) => m.FlightReviewPageModule),
    canActivate: [AuthGuard],
    data: { title: 'FlexiCancel V2 Review' },
  },
  {
    path: 'flight-booking/v2/booking-confirmation/:bookingId',
    loadChildren: () =>
      import(
        './modules/booking/flights-v2/booking-confirmation/booking-confirmation.module'
      ).then((m) => m.FlightReviewPageModule),
    data: { title: 'Flight Booking V2 Confirmation' },
  },
  {
    path: 'flexicancel/v2/booking-confirmation/:bookingId',
    loadChildren: () =>
      import(
        './modules/booking/flights-v2/booking-confirmation/booking-confirmation.module'
      ).then((m) => m.FlightReviewPageModule),
    data: { title: 'FlexiCancel V2 Confirmation' },
  },

  // ===== Flights module (copy of flights-v2, clean routes) =====
  {
    path: 'flights/search',
    loadChildren: () =>
      import(
        './modules/booking/flights/flights-search/flights-search.module'
      ).then((m) => m.FlightsSearchPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Flight Search' },
  },
  {
    path: 'flexicancel/search',
    loadChildren: () =>
      import(
        './modules/booking/flights/flights-search/flights-search.module'
      ).then((m) => m.FlightsSearchPageModule),
    canActivate: [AuthGuard],
    data: { title: 'FlexiCancel Search' },
  },
  {
    path: 'flights/search-results',
    loadChildren: () =>
      import(
        './modules/booking/flights/flights-search-results/flights-search-results.module'
      ).then((m) => m.FlightsSearchResultsPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Flight Search Results' },
  },
  {
    path: 'flexicancel/search-results',
    loadChildren: () =>
      import(
        './modules/booking/flights/flights-search-results/flights-search-results.module'
      ).then((m) => m.FlightsSearchResultsPageModule),
    canActivate: [AuthGuard],
    data: { title: 'FlexiCancel Search Results' },
  },
  {
    path: 'flights/booking-review/:resultId',
    loadChildren: () =>
      import(
        './modules/booking/flights/flights-booking-review/flights-booking-review.module'
      ).then((m) => m.FlightsBookingReviewPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Flight Booking Review' },
  },
  {
    path: 'flexicancel/booking-review/:resultId',
    loadChildren: () =>
      import(
        './modules/booking/flights/flights-booking-review/flights-booking-review.module'
      ).then((m) => m.FlightsBookingReviewPageModule),
    canActivate: [AuthGuard],
    data: { title: 'FlexiCancel Booking Review' },
  },
  {
    path: 'flights/booking-confirmation/:bookingId',
    loadChildren: () =>
      import(
        './modules/booking/flights/flights-booking-confirmation/flights-booking-confirmation.module'
      ).then((m) => m.FlightsBookingConfirmationPageModule),
    data: { title: 'Flight Booking Confirmation' },
  },
  {
    path: 'flexicancel/booking-confirmation/:bookingId',
    loadChildren: () =>
      import(
        './modules/booking/flights/flights-booking-confirmation/flights-booking-confirmation.module'
      ).then((m) => m.FlightsBookingConfirmationPageModule),
    data: { title: 'FlexiCancel Booking Confirmation' },
  },

  {
    path: 'hotel/search',
    loadChildren: () =>
      import('./modules/booking/hotels/search/search.module').then(
        (m) => m.SearchPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Hotel Search' },
  },
  {
    path: 'hotel/search-results',
    loadChildren: () =>
      import(
        './modules/booking/hotels/search-results/search-results.module'
      ).then((m) => m.SearchResultsPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Hotel Search Results' },
  },
  {
    path: 'hotel/details/:hotelId',
    loadChildren: () =>
      import(
        './modules/booking/hotels/hotel-details/hotel-details.module'
      ).then((m) => m.HotelDetailsPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Hotel Details' },
  },
  {
    path: 'hotel/booking-review/:bookingId',
    loadChildren: () =>
      import(
        './modules/booking/hotels/booking-review/booking-review.module'
      ).then((m) => m.BookingReviewPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Hotel Booking Review' },
  },
  {
    path: 'hotel/booking-confirmed/:bookingReferenceId',
    loadChildren: () =>
      import(
        './modules/booking/hotels/booking-confirmed/booking-confirmed.module'
      ).then((m) => m.BookingConfirmedPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Hotel Booking Confirmed' },
  },
  {
    path: 'hotel/booking-details/:bookingReferenceId',
    loadChildren: () =>
      import(
        './modules/booking/hotels/booking-details/booking-details.module'
      ).then((m) => m.BookingDetailsPageModule),
    data: { title: 'Hotel Booking Details' },
  },
  {
    path: 'hotel/wishlist',
    loadChildren: () =>
      import('./modules/booking/hotels/wishlist/wishlist.module').then(
        (m) => m.WishlistPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Hotel Wishlist' },
  },
  {
    path: 'hotel-deals/home',
    loadChildren: () =>
      import('./modules/booking/deals/deal-home/deal-home.module').then(
        (m) => m.DealsHomePageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Hotel Deals Home' },
  },
  {
    path: 'hotel-deals/search-results',
    loadChildren: () =>
      import(
        './modules/booking/deals/deal-search-result/deal-search-result.module'
      ).then((m) => m.DealSearchResultPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Hotel Deals Search Results' },
  },
  {
    path: 'hotel-deals/details/:hotelId',
    loadChildren: () =>
      import('./modules/booking/deals/deal-detail/deal-detail.module').then(
        (m) => m.DealDetailsPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Hotel Deals Details' },
  },
  {
    path: 'hotel-deals/booking-review/:bookingId',
    loadChildren: () =>
      import(
        './modules/booking/deals/deal-booking-review/deal-booking-review.module'
      ).then((m) => m.DealBookingReviewPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Hotel Deals Review' },
  },
  {
    path: 'hotel-deals/booking-confirmed/:bookingReferenceId',
    loadChildren: () =>
      import(
        './modules/booking/deals/deal-booking-confirmed/deal-booking-confirmed.module'
      ).then((m) => m.DealBookingConfirmedPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Hotel Booking Confirmed' },
  },
  {
    path: 'hotel-deals/booking-details/:bookingReferenceId',
    loadChildren: () =>
      import(
        './modules/booking/deals/deal-booking-details/deal-booking-details.module'
      ).then((m) => m.DealBookingDetailsPageModule),
    data: { title: 'Hotel Deals Booking Details' },
  },

  {
    path: 'tours-and-experiences/v2/search',
    loadChildren: () =>
      import(
        './modules/booking/tour-and-experience/tour-and-experience-search/tour-and-experience-search.module'
      ).then((m) => m.TourAndExperienceSearchModule),
    canActivate: [AuthGuard],
    data: { title: 'Tours and Attractions Search' },
  },
  {
    path: 'tours-and-experiences/v2/search-results',
    loadChildren: () =>
      import(
        './modules/booking/tour-and-experience/tour-and-experience-search-results/tour-and-experience-search-results.module'
      ).then((m) => m.TourAndExperienceSearchResultsModule),
    canActivate: [AuthGuard],
    data: { title: 'Tours and Experiences Listing' },
  },
  {
    path: 'tours-and-experiences/v2/details/:productId',
    loadChildren: () =>
      import(
        './modules/booking/tour-and-experience/tour-and-experience-details/tour-and-experience-details.module'
      ).then((m) => m.TourAndExperienceDetailsModule),
    canActivate: [AuthGuard],
    data: { title: 'Tours and Experiences Details' },
  },
  {
    path: 'tours-and-experiences/v2/booking-review/:productId/:optionId',
    loadChildren: () =>
      import(
        './modules/booking/tour-and-experience/tour-and-experience-booking-review/tour-and-experience-booking-review.module'
      ).then((m) => m.TourAndExperienceBookingReviewModule),
    canActivate: [AuthGuard],
    data: { title: 'Tours and Experiences Review' },
  },
  {
    path: 'tours-and-experiences/v2/confirmation/:bookingReferenceId',
    loadChildren: () =>
      import(
        './modules/booking/tour-and-experience/tour-and-experience-booking-confirmation/tour-and-experience-booking-confirmation.module'
      ).then((m) => m.TourAndExperienceBookingConfirmationModule),
    data: { title: 'Tours and Experiences Confirmation' },
  },
  {
    path: 'order-details/:id',
    loadChildren: () =>
      import('./modules/order-details/order-details.module').then(
        (m) => m.OrderDetailsPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Order Details' },
  },
  {
    path: 'booking-history',
    loadChildren: () =>
      import('./modules/booking-history/booking-history.module').then(
        (m) => m.BookingHistoryPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Booking History' },
  },
  {
    path: 'upgrade-subscription',
    loadChildren: () =>
      import('./modules/blank-page/blank-page.module').then(
        (m) => m.BlankPagePageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Upgrade Subscription' },
  },
  {
    path: 'online-offers',
    loadChildren: () =>
      import(
        './modules/shopping/online-shopping-home/online-shopping-home.module'
      ).then((m) => m.OnlineShoppingHomePageModule),
    canActivate: [AuthGuard],
    data: { title: 'Online Offers' },
  },
  {
    path: 'coupon-detail/:couponId/:airport',
    loadChildren: () =>
      import(
        './modules/shopping/coupon-detail-home/coupon-detail-home.module'
      ).then((m) => m.CouponDetailHomePageModule),
    canActivate: [AuthGuard],
    data: { title: 'Coupon Detail' },
  },
  {
    path: 'blank',
    loadChildren: () =>
      import('./modules/blank-page/blank-page.module').then(
        (m) => m.BlankPagePageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Blank' },
  },
  {
    path: 'booking-complete/:bookingReferenceId',
    loadChildren: () =>
      import('./modules/blank-page/blank-page.module').then(
        (m) => m.BlankPagePageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Booking Complete' },
  },
  {
    path: 'customer-support/:bookingReferenceId',
    loadChildren: () =>
      import('./modules/blank-page/blank-page.module').then(
        (m) => m.BlankPagePageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Customer Support' },
  },
  {
    path: 'notification-list',
    loadChildren: () =>
      import('./modules/notification-list/notification-list.module').then(
        (m) => m.NotificationListPageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Notification List' },
  },
  {
    path: 'service/booking-details/:bookingReferenceId',
    loadChildren: () =>
      import(
        './modules/service-request-details/service-request-details.module'
      ).then((m) => m.ServiceRequestDetailsPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Service Booking Details' },
  },
  {
    path: 'back_clicked',
    loadChildren: () =>
      import('./modules/blank-page/blank-page.module').then(
        (m) => m.BlankPagePageModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'Back Clicked' },
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/error/error.module').then((m) => m.ErrorPageModule),
    data: { title: 'Error' },
  },
  {
    path: 'redirecting',
    loadChildren: () =>
      import('./modules/blank-page/blank-page.module').then(
        (m) => m.BlankPagePageModule
      ),
    data: { title: 'Redirecting' },
  },
  {
    path: 'tours-and-experiences-city-list',
    loadChildren: () =>
      import(
        './modules/tours-and-experiences/tours-and-experiences-city-list/tours-and-experiences-city-list.module'
      ).then((m) => m.ToursAndExperiencesCityListPageModule),
    canActivate: [AuthGuard],
    data: { title: 'Tours and Experiences City List' },
  },
  {
    path: '',
    redirectTo: 'membership/hotel_book',
    pathMatch: 'full',
    data: { title: 'Redirect' },
  },
  {
    path: 'booking-review',
    loadChildren: () =>
      import('./modules/esim/booking-review/booking-review.module').then(
        (m) => m.BookingReviewPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full',
    data: { title: 'Not Found' },
  },
  // {
  //   path: 'events',
  //   loadChildren: () =>
  //     import('./modules/events/events-home/events-home.module').then(
  //       (m) => m.EventsHomePageModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'event/:eventId',
  //   loadChildren: () =>
  //     import('./modules/events/event-detail/event-detail.module').then(
  //       (m) => m.EventDetailPageModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'shopping',
  //   loadChildren: () =>
  //     import('./modules/shopping/shopping-home/shopping-home.module').then(
  //       (m) => m.ShoppingHomePageModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'shopping/deals',
  //   loadChildren: () =>
  //     import('./modules/shopping/shopping-deals/shopping-deals.module').then(
  //       (m) => m.ShoppingDealsPageModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'shopping/deal/:detailId',
  //   loadChildren: () =>
  //     import('./modules/shopping/deal-detail/deal-detail.module').then(
  //       (m) => m.DealDetailPageModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'shopping/coupons',
  //   loadChildren: () =>
  //     import('./modules/shopping/coupons-home/coupons-home.module').then(
  //       (m) => m.CouponsHomePageModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'shopping/coupons/:couponId',
  //   loadChildren: () =>
  //     import('./modules/shopping/coupons-detail/coupons-detail.module').then(
  //       (m) => m.CouponsDetailPageModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'shopping/products',
  //   loadChildren: () =>
  //     import('./modules/shopping/products-home/products-home.module').then(
  //       (m) => m.ProductsHomePageModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'shopping/products/:department',
  //   loadChildren: () =>
  //     import('./modules/shopping/products-list/products-list.module').then(
  //       (m) => m.ProductsListPageModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'shopping/products/:department/:category',
  //   loadChildren: () =>
  //     import('./modules/shopping/products-list/products-list.module').then(
  //       (m) => m.ProductsListPageModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'shopping/products/:department/:category/:subCategory',
  //   loadChildren: () =>
  //     import('./modules/shopping/products-list/products-list.module').then(
  //       (m) => m.ProductsListPageModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'shopping/product/:productId',
  //   loadChildren: () =>
  //     import('./modules/shopping/product-details/product-details.module').then(
  //       (m) => m.ProductDetailsPageModule
  //     ),
  //   canActivate: [AuthGuard],
  // },

  // {
  //   path: 'birthday',
  //   loadChildren: () =>
  //     import('./modules/birthday/birthday-home/birthday-home.module').then(
  //       (m) => m.BirthdayHomePageModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'birthday/:birthdayId',
  //   loadChildren: () =>
  //     import('./modules/birthday/birthday-detail/birthday-detail.module').then(
  //       (m) => m.BirthdayDetailPageModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'validator',
  //   loadChildren: () =>
  //     import('./modules/serial-validator/serial-validator.module').then(
  //       (m) => m.SerialValidatorPageModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'stays',
  //   loadChildren: () =>
  //     import('./modules/stay/stay-home/stay-home.module').then(
  //       (m) => m.StayHomePageModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'stays/:country/:city',
  //   loadChildren: () =>
  //     import('./modules/stay/stay-home/stay-home.module').then(
  //       (m) => m.StayHomePageModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'stay/:stayId',
  //   loadChildren: () =>
  //     import('./modules/stay/stay-detail/stay-detail.module').then(
  //       (m) => m.StayDetailPageModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
